import Vue from 'vue'
import VueRouter from 'vue-router'
import Homeindex from '@/views/index.vue'
import Payindex from '@/views/pay.vue'
import Liveindex from '@/views/live.vue'
import liveCenter from '@/views/liveCenter.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Homeindex,
    meta: { title: 'index' }
   
  },
  {
    path: '/pay',
    name: 'pay',
    component: Payindex,
    meta: { title: 'pay' }
   
  },
  {
    path: '/live',
    name: 'live',
    component: Liveindex,
    meta: { title: 'live' }
   
  },
  {
    path: '/liveCenter',
    name: 'liveCenter',
    component: liveCenter,
    meta: { title: 'liveCenter' }
   
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})




export default router
